import { service } from '@/ajax/request'

export const getIntelligentList = (params) => (
  service({
    url: '/intelligentDialectics/intelligentInfoPage',
    method: 'POST',
    params
  })
)

export const getIntelligentType = () => (
  service({
    url: '/intelligentDialectics/getIntelligentType',
    method: 'POST',
  })
)

export const saveOrUpdateIntelligent = (params: any) => (
  service({
    url: '/intelligentDialectics/saveOrUpdateIntelligent',
    method: 'POST',
    params
  })
)

// ===== 品牌方智能评估配置 =====

// 品牌方分页列表
export const getMerchantIntelligentList = (params: {
  merchantId: string | number
  symptomName?: string
  symptomType?: string
  symptomStatus?: number | string
  pageNum: number
  pageSize: number
}) => (
  service({
    url: '/intelligentDialectics/merchantInfoPage',
    method: 'POST',
    params
  })
)

// 品牌方新增/编辑自建项
export const saveOrUpdateMerchantIntelligent = (params: {
  id?: number | null
  merchantId: string | number
  symptomType: string
  symptomName: string
  gender: number
  symptomStatus?: number
}) => (
  service({
    url: '/intelligentDialectics/merchantSaveOrUpdate',
    method: 'POST',
    params
  })
)

// 品牌方状态切换（status 传当前状态，后端取反）
export const updateMerchantIntelligentStatus = (params: {
  merchantId: string | number
  id: number
  customFlag: number
  status: number
}) => (
  service({
    url: '/intelligentDialectics/merchantUpdateStatus',
    method: 'POST',
    params
  })
)

// 品牌方删除自建项
export const deleteMerchantIntelligent = (params: {
  merchantId: string | number
  id: number
}) => (
  service({
    url: '/intelligentDialectics/merchantDelete',
    method: 'POST',
    params
  })
)

